"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUid = void 0;
var getUid = function () {
    return (String.fromCharCode(Math.floor(Math.random() * 26) + 97) +
        Math.random().toString(16).slice(2) +
        Date.now().toString(16).slice(4));
};
exports.getUid = getUid;
